// @flow

import React from "react";
import { Marker, Popup } from "react-leaflet";
import type { MarkerProps } from "../types";
// import IconTest from './marker_icon.svg';
import MarkerIcon from "./MarkerIcon";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";

// export const pointerIcon = new L.Icon({
//   iconUrl: 'prova.svg',
//   iconRetinaUrl: 'prova.svg',
//   iconAnchor: [5, 55],
//   popupAnchor: [10, -44],
//   iconSize: [25, 55],
// });
const iconMarkup = renderToStaticMarkup(<MarkerIcon />);

const customMarkerIcon = divIcon({
  html: iconMarkup,
  iconAnchor: [19, 52],
});

const MarkerPopup = ({
  "@id": url,
  title,
  latitude,
  longitude,
  country,
  city,
  description,
  translations,
}: MarkerProps) => {
  return (
    <Marker position={[latitude, longitude]} icon={customMarkerIcon}>
      <Popup>
        <div className="marker-popup">
          <h6>{title}</h6>
          {(country && country.length) || (city && city.length) ? (
            <div className="location">
              <i className="fas fa-map-marker-alt" />
              {country && country.length ? country : ""}
              {country && country.length && city && city.length ? ", " : " "}
              {city && city.length ? city : ""}
            </div>
          ) : (
            ""
          )}
          {description.length ? (
            <p className="description">{description}</p>
          ) : (
            ""
          )}
          <a href={url} className="open-card">
            {translations
              ? translations["open_the_card_label"]
              : "Open the card"}
          </a>
        </div>
      </Popup>
    </Marker>
  );
};

export default MarkerPopup;
